// extracted by mini-css-extract-plugin
export var buttons = "_bu-0";
export var buttonsActive = "_bu-h";
export var cancelConfirm = "_bu-1";
export var closeButton = "_bu-2";
export var column = "_bu-3";
export var container = "_bu-4";
export var detailHeader = "_bu-6";
export var detailTitle = "_bu-7";
export var detailsContent = "_bu-5";
export var header = "_bu-8";
export var headerWithClose = "_bu-9";
export var icon = "_bu-a";
export var infoIcon = "_bu-c";
export var informationContainer = "_bu-b";
export var sideDrawer = "_bu-d";
export var sideDrawerOpen = "_bu-e";
export var stickyFooter = "_bu-f";
export var typeOption = "_bu-g";